/**
 * @file 直播相关接口
 * @author zhanghaohan
 */
import 'whatwg-fetch';
import {stringify} from 'qs';
import {spyRequest as request} from '../log/index';
import createDeviceId from '../../../utils/createDeviceId';
import API from './api';

export const deviceId = createDeviceId();

/**
 * 获取剧本关联直播间状态
 * @returns Promise
 */
export const getLiveStatus = async params => {
    return request(
        API.GET_LIVE_STATUS, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取直播间分类信息
 * @returns Promise
 */
export const getLiveCategory = () => {
    const params = {
        timestamp: Date.now(), // 毫秒时间戳
        sdkbuildpath: 21820, // 写死，同pc开播助手
        screen: 0, // 竖屏
        ts: Math.floor(Date.now() / 1000), // 秒时间戳
        cuid: deviceId,
        is_test_live: 0, // 是否测试直播间
        from_app: 'pc', // 写死，同pc开播助手
        type: 1, // 1:新建；2:修改
        ask_answer: 0,
        has_speech_connect: 0, // 连麦
        subapp_type: 'bd', // 写死，同pc开播助手
        is_show_baike: 0,
        _sdk_version: window.navigator.userAgent,
        is_pay_column: 0,
        _client_type: 1
    };
    return request(
        `${API.GET_LIVE_CATEGORY}?${stringify(params)}`
    );
};

/**
 * 获取预约直播间默认表单数据
 * @returns Promise
 */
export const getInitialReserveForm = async params => {
    return request(
        API.GET_INITIAL_RESERVE_FORM, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 更新预约直播间默认表单数据
 * @returns Promise
 */
export const setInitialReserveForm = async params => {
    return request(
        API.SET_INITIAL_RESERVE_FORM, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 创建预约直播间
 * @returns Promise
 */
export const reserveLive = async params => {
    return request(
        API.RESERVE, {
            method: 'POST',
            body: {
                timestamp: Date.now(), // 毫秒时间戳
                sdkbuildpath: 21820, // 写死，同pc开播助手
                screen: 0, // 竖屏
                ts: Math.floor(Date.now() / 1000), // 秒时间戳
                cuid: deviceId,
                is_test_live: 0, // 是否测试直播间，0:线上，1:测试
                from_app: 'pc', // 写死
                type: 1, // 1:新建；2:修改
                ask_answer: 0,
                has_speech_connect: 0, // 连麦
                subapp_type: 'bd', // 写死，同pc开播助手
                is_show_baike: 0,
                _sdk_version: window.navigator.userAgent,
                is_pay_column: 0,
                _client_type: 1,
                template_id: 2, // 电商主播
                is_digital_human: 1, // 写死，数字人直播间值为1
                ...params
            }
        }
    );
};

/**
 * 取消预约直播间
 * @returns Promise
 */
export const cancelReserveLive = async params => {
    return request(
        API.CANCEL_RESERVE, {
            method: 'POST',
            body: {
                ...params
            }
        }
    );
};

/**
 * 预约直播间控制
 * @returns Promise
 */
export const controlReserveLive = async params => {
    return request(
        API.RESERVE_CONTROL, {
            method: 'POSTJSON',
            body: {
                ...params
            }
        }
    );
};

/**
 * 文心辅写标题
 * @return Promise
 */
export const getErnieTitle = async params => {
    return request(
        API.GET_ERNIE_LIVE_TITLE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 文心辅写描述
 * @return Promise
 */
export const getErnieDesc = async params => {
    return request(
        API.GET_ERNIE_LIVE_DESC, {
            method: 'POSTJSON',
            body: params
        }
    );
};
/**
 * 文心辅写标签
 * @return Promise
 */
export const getErnieLabel = async params => {
    return request(
        API.GET_ERNIE_LIVE_LABEL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取剧本预览流地址
 * @returns Promise
 */
export const getPreviewFlow = async params => {
    return request(
        API.GET_PREVIEW_FLOW, {
            method: 'POSTJSON',
            body: params
        }
    );
};


/**
 * 关播
 * @returns Promise
 */
export const closeRoom = async params => {
    return request(
        API.CLOSE_ROOM, {
            method: 'POST',
            body: {
                from_app: 'pc',
                ...params
            }
        }
    );
};

/**
 * 去推流
 * @returns Promise
 */
export const setLivePushStart = async params => {
    return request(
        API.SET_LIVE_PUSH_START, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 保存并推流
 * @returns Promise
 */
export const saveLiveAndPush = async params => {
    return request(
        API.SAVE_AND_PUSH_LIVE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取推流详情
 * @returns Promise
 */
export const getLivePushDetail = async params => {
    return request(
        API.GET_LIVE_PUSH_DETAIL, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 停止推流
 * @returns Promise
 */
export const setLivePushStop = async params => {
    return request(
        API.SET_LIVE_PUSH_STOP, {
            method: 'POSTJSON',
            body: params
        }
    );
};


/**
 * 推流授权
 * @returns Promise
 */
export const setLivePushAgree = async params => {
    return request(
        API.SET_PUSH_LIVE_AGREE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 推流授权详情
 * @returns Promise
 */
export const getLivePushAgree = async params => {
    return request(
        API.GET_PUSH_LIVE_AGREE, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 站外直播日志
 * @returns Promise
 */
export const setLivePushLog = async params => {
    return request(
        API.SET_LIVE_PUSH_LOG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取拉流助手配置
 * @returns Promise
 */
export const getVirtualCameraConfig = async params => {
    return request(
        API.GET_VIRTUAL_CAMERA_CONFIG, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 保存外部直播间&抓取
 * @returns Promise
 */
export const setOutsideLiveRoom = async params => {
    return request(
        API.SET_OUTSIDE_LIVE_ROOM, {
            method: 'POSTJSON',
            body: params
        }
    );
};

/**
 * 获取拉流助手状态
 * @returns Promise
 */
export const getVirtualCameraStatus = async () => {
    return Promise.race([
        request(
            API.GET_VIRTUAL_CAMERA_STATUS, {
                method: 'GET'
            }
        ), new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error('promise timeout'));
            }, 5000);
        })
    ]).then(
        res => {
            return res;
        }
    ).catch(
        err => {
            return err;
        }
    );
};

/**
 * 开始拉流并推送拉流助手
 * @returns Promise
 */
export const setVirtualCameraStart = async params => {
    return Promise.race([
        request(
            API.SET_VIRTUAL_CAMERA_START, {
                method: 'POSTJSON',
                body: params
            }
        ), new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error('promise timeout'));
            }, 5000);
        })
    ]).then(
        res => {
            return res;
        }
    ).catch(
        err => {
            return err;
        }
    );
};

/**
 * 拉流助手停止拉流
 * @returns Promise
 */
export const setVirtualCameraStop = async () => {
    return Promise.race([
        request(
            API.SET_VIRTUAL_CAMERA_STOP, {
                method: 'POSTJSON',
                body: {}
            }
        ), new Promise((resolve, reject) => {
            setTimeout(() => {
                reject(new Error('promise timeout'));
            }, 5000);
        })
    ]).then(
        res => {
            return res;
        }
    ).catch(
        err => {
            return err;
        }
    );
};
